<nav class="navbar navbar-expand-md navbar-light navbar-content">
  <ul class="navbar-nav mr-auto">
    @for (tab of tabs; track tab) {
      @if (!tab.show || tab.show(storageService.role)) {
        <li class="nav-item" [class.active]="selected === tab.route">
          <a class="nav-link" [routerLink]="tab.route" (click)="changeTab(tab.route)">
            {{ tab.title | translate }}
          </a>
        </li>
      }
    }
  </ul>
</nav>
